import { render, staticRenderFns } from "./SaleTaxActionDelete.vue?vue&type=template&id=3a411c60&"
import script from "./SaleTaxActionDelete.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports